if (!customElements.get('ly-header-noticebar')) {
    customElements.define('ly-header-noticebar', class extends HTMLElement {

        #interval = Number(this.dataset.interval || 5) * 1000
        #itemHeight = Number(this.dataset.height)

        #transfer = null
        #timerId = null

        #index = 0
        #length = 0

        connectedCallback() {
            this.#transfer = this.querySelector('.ly-header-noticebar-list')

            if (!this.#transfer) return

            const children = Array.from(this.#transfer.children)
            this.#length = children.length

            if (this.#length <= 1) return

            // 克隆第一个节点
            const first = children[0].cloneNode(true)
            first.dataset.clone = true
            this.#transfer.appendChild(first)

            this.startPlay()

            this.addEventListener('mouseenter', this.stopPlay)
            this.addEventListener('mouseleave', this.startPlay)

        }

        disconnectedCallback() {
            this.stopPlay()

            this.removeEventListener('mouseenter', this.stopPlay)
            this.removeEventListener('mouseleave', this.startPlay)
        }

        get index() {
            return this.#index
        }

        set index(value) {
            this.#index = value

            // 开启动画
            this.#transfer.style.transition = 'transform 0.3s ease'
            this.#transfer.style.transform = `translateY(-${this.#index * this.#itemHeight}px)`

            // 到达克隆节点（最后一个）
            if (this.#index === this.#length) {
                setTimeout(() => {
                    // 关闭动画瞬间跳回
                    this.#transfer.style.transition = 'none'
                    this.#index = 0
                    this.#transfer.style.transform = `translateY(0px)`
                }, 300) // 与 transition 时间一致
            }
        }

        startPlay = () => {
            if (this.#timerId) return

            this.#timerId = setInterval(() => {
                this.index = this.index + 1
            }, this.#interval)
        }

        stopPlay = () => {
            if (!this.#timerId) return
            clearInterval(this.#timerId)
            this.#timerId = null
        }
    })
}